export default __webpack_public_path__ + "static/media/023-right turn.01949354.png";